import React from "react";
import { high } from "nc-lightapp-front";
import {langCheck} from "Pub/js/utils";
const { Refer } = high;

export default function(props = {}) {
    var conf = {
        queryTreeUrl: "/nccloud/riart/ref/mdClassDefaultEntityRefTreeAction.do",
        refType: "tree",
        isTreelazyLoad: false,
        refName: langCheck('0000PUB-000046'),/* 国际化处理： 元数据*/
        rootNode: { refname: langCheck('0000PUB-000046'), refpk: "root" },/* 国际化处理： 元数据*/
        queryCondition: { isWorkbench: 'Y' }, //此参数可以查出子表元数据
        onlyLeafCanSelect: true,
    };

    return <Refer {...Object.assign(conf, props)} />;
}
